class VariantsPicker extends HTMLElement {
  constructor() {
    super()

    this.variants = this.querySelectorAll('[data-variant-ids]');

    const shopifyWrapper = this.closest('[id^="shopify-section-"]')
    const sectionInstanceId = shopifyWrapper?.id?.replace(
      'shopify-section-',
      ''
    )

    this.renderAllSections = window.renderAllSections
    this.sectionsRender = [
      {
        title: sectionInstanceId,
        selector: [
          '[data-product-medias-slider]',
          '[data-product-subtitle-container]', 
          '[data-product-form-container]',
          '[data-selected-variant]',
          '[data-sticky-product-bar]'
        ],
      },
    ]
  }

  connectedCallback() {
    console.log("connectedCallback renderVarianteInfos")

    this.variants.forEach(variant => {
      variant.addEventListener('click', () => {
        this.updateCartSections(variant)
      })
    })
  }

  disconnectedCallback() {
    this.variants.forEach(variant => {
      variant.removeEventListener('click', () => {
        this.updateCartSections(variant)
      })
    })
  }

  async updateCartSections(variant) {
    
    // remove all checked classes
    document.querySelectorAll('.variant-picker-label.checked').forEach(label => {
      label.classList.remove('checked')
    })

    const variantId = variant.getAttribute('data-variant-ids')

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);

    history.pushState('', '', url.toString())

    document.querySelectorAll('[data-atc-button]').forEach(button => {
      button.disabled = true;
    })

    await this.renderAllSections(this.sectionsRender, url)


    // add checked class to the variant label by for element ex :label for="variant-49272570249556"
    document.querySelectorAll(`label[for="variant-${variantId}"]`).forEach(label => {
      label.classList.add('checked')
    })
  }
}

// Enregistre le composant personnalisé
customElements.define('variants-picker', VariantsPicker)
